import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { FadeUp } from "@/components/Motion";
import { CheckCircle2, Gift } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const COPY = {
  de: { verify: "Wir stellen deinen Gutschein aus...", ok_t: "Danke — dein Gutschein ist unterwegs!", ok_s: "Wir haben den Code per E-Mail versendet. Der Beschenkte kann ihn direkt beim nächsten Einkauf einlösen.", back: "Weiter zum Shop" },
  en: { verify: "Issuing your gift card...", ok_t: "Thank you — your gift is on its way!", ok_s: "We just sent the code by email. The recipient can redeem it at the next order.", back: "Continue to shop" },
  it: { verify: "Emissione del buono in corso...", ok_t: "Grazie — il tuo regalo è in viaggio!", ok_s: "Abbiamo appena inviato il codice via email. Il destinatario potrà utilizzarlo al prossimo ordine.", back: "Continua nello shop" },
  ja: { verify: "ギフトカードを発行中...", ok_t: "ありがとうございます——ギフトをお届けします!", ok_s: "コードをメールでお送りしました。贈られた方は次回のご注文でご利用いただけます。", back: "ショップへ戻る" },
  zh: { verify: "正在生成礼品卡...", ok_t: "谢谢——您的礼物正在路上!", ok_s: "兑换码已通过邮件发送,收礼人可在下次下单时使用。", back: "返回商店" },
};

export default function GiftCardSuccess() {
  const { lang } = useI18n();
  const L = COPY[lang] || COPY.de;
  const [params] = useSearchParams();
  const [status, setStatus] = useState("polling");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (attempts < 20) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="pt-40 pb-32 min-h-screen flex items-center justify-center" data-testid="gift-card-success">
      <FadeUp className="max-w-lg text-center px-6">
        {status === "polling" && (
          <>
            <div className="w-16 h-16 border border-gold border-t-transparent rounded-full animate-spin mx-auto mb-8" />
            <p className="font-display text-[11px] tracking-[0.3em] text-cream/60">{L.verify}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <Gift className="w-16 h-16 text-gold mx-auto mb-8" />
            <h1 className="font-editorial italic font-light text-5xl text-cream mb-6">{L.ok_t}</h1>
            <p className="text-cream/70 font-body text-lg mb-10">{L.ok_s}</p>
            <Link to="/shop" data-testid="gc-success-continue" className="inline-block px-8 py-4 bg-gold text-black font-display text-[11px] tracking-[0.3em] gold-shine" style={{ background: "#C9A24C" }}>
              → {L.back}
            </Link>
          </>
        )}
      </FadeUp>
    </div>
  );
}
